import React, { useContext, useEffect, useMemo, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import ReactLoading from "react-loading";
import {
  Tabs,
  Card,
  List,
  Input,
  Button,
  Space,
  Select,
  Table,
  InputNumber,
  Modal,
  message,
  Dropdown,
  Checkbox,
} from "antd";
import swal from "sweetalert";
import {
  EditOutlined,
  CloseOutlined,
  MenuOutlined,
  CheckOutlined,
  PlusSquareOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import useAxios from "../../hooks/useAxios";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { v4 } from "uuid";

const { TabPane } = Tabs;

const CompetencyConf = () => {
  const api = useAxios();
  const [load, setLoad] = useState(false);
  const userRole = useRole();

  // Permission states
  const [canCreateInterviewRound, setCanCreateInterviewRound] = useState(false);
  const [canEditInterviewRound, setCanEditInterviewRound] = useState(false);
  const [canDeleteInterviewRound, setCanDeleteInterviewRound] = useState(false);
  const [canCreateCompetencies, setCanCreateCompetencies] = useState(false);
  const [canEditCompetencies, setCanEditCompetencies] = useState(false);
  const [canDeleteCompetencies, setCanDeleteCompetencies] = useState(false);
  const [canCreateQuestionBank, setCanCreateQuestionBank] = useState(false);
  const [canEditQuestionBank, setCanEditQuestionBank] = useState(false);
  const [canDeleteQuestionBank, setCanDeleteQuestionBank] = useState(false);
  const [canAddInterviewSetup, setCanAddInterviewSetup] = useState(false);
  const [canEditInterviewSetup, setCanEditInterviewSetup] = useState(false);
  const [canDeleteInterviewSetup, setCanDeleteInterviewSetup] = useState(false);
  const [canSubmitInterviewSetup, setCanSubmitInterviewSetup] = useState(false);
  const [canCreateCompetencyBinding, setCanCreateCompetencyBinding] = useState(false);

  const checkPermissions = async () => {
    try {
      const checks = [
        { key: "createIR", permission: "create_competency_interview_round" },
        { key: "editIR", permission: "edit_competency_interview_round" },
        { key: "deleteIR", permission: "delete_competency_interview_round" },
        { key: "createComp", permission: "create_Competencies" },
        { key: "editComp", permission: "edit_Competencies" },
        { key: "deleteComp", permission: "delete_Competencies" },
        { key: "createQB", permission: "create_competency_question_bank" },
        { key: "editQB", permission: "edit_competency_question_bank" },
        { key: "deleteQB", permission: "delete_competency_question_bank" },
        { key: "addSetup", permission: "add_competency_interview_setup" },
        { key: "editSetup", permission: "edit_competency_interview_setup" },
        { key: "deleteSetup", permission: "delete_competency_interview_setup" },
        { key: "submitSetup", permission: "submit_competency_interview_setup" },
        { key: "createBinding", permission: "create_competency_binding" },
      ];
      const results = await Promise.all(
        checks.map((c) => checkPermission(userRole, "competency_setup_module", c.permission))
      );
      setCanCreateInterviewRound(results[0]);
      setCanEditInterviewRound(results[1]);
      setCanDeleteInterviewRound(results[2]);
      setCanCreateCompetencies(results[3]);
      setCanEditCompetencies(results[4]);
      setCanDeleteCompetencies(results[5]);
      setCanCreateQuestionBank(results[6]);
      setCanEditQuestionBank(results[7]);
      setCanDeleteQuestionBank(results[8]);
      setCanAddInterviewSetup(results[9]);
      setCanEditInterviewSetup(results[10]);
      setCanDeleteInterviewSetup(results[11]);
      setCanSubmitInterviewSetup(results[12]);
      setCanCreateCompetencyBinding(results[13]);
    } catch (err) {
      console.error("Error checking competency permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedQueRowKeys, setSelectedQueRowKeys] = useState([]);
  const [selectedQueRow, setSelectedQueRow] = useState([]);
  const [openCompetency, setOpenCompetency] = useState(false);
  const [competencies, setCompetencies] = useState([]);
  const [competencyId, setCompetencyId] = useState(null);
  const [competencyName, setCompetencyName] = useState("");
  const [editCompetencyName, setEditCompetencyName] = useState("");
  const [openAddQuestion, setOpenAddQuestion] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [questionsDataSource, setQuestionsDataSource] = useState([]);
  const [question, setQuestion] = useState("");
  const [editQuestion, setEditQuestion] = useState("");
  const [openAddInterviewRounds, setOpenAddInterviewRounds] = useState(false);
  const [interviewRounds, setInterviewRounds] = useState([]);
  const [interview, setInterview] = useState("");
  const [competencySearch, setCompetencySearch] = useState(null);
  const [questionSearch, setQuestionSearch] = useState(null);
  const [competencybasedQuestionSearch, setCompetencybasedQuestionSearch] =
    useState(null);
  const [editInterviewRound, setEditInterviewRound] = useState("");
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [mapping, setMapping] = useState([]);
  const [designationId, setDesignationId] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);
  const [interviewsRound, setInterviewsRound] = useState([]);
  const [competenciesId, setCompetenciesId] = useState([]);

  const handleMenuClick = (e) => {
    e.stopPropagation(); // Prevent dropdown from closing on checkbox click
  };
  const [
    designationBasedinterviewCompetencyQuestion,
    setDesignationBasedinterviewCompetencyQuestion,
  ] = useState([]);
  const [
    designationBasedinterviewAndCompetency,
    setDesignationBasedinterviewAndCompetency,
  ] = useState([]);
  const [competencyWithQuetionBank, setCompetencyWithQuetionBank] = useState(
    [],
  );
  const [competencyQuestionCount, setCompetencyQuestionCount] = useState([]);

  const [tableData, setTableData] = useState([
    // {
    //   id: v4(),
    //   interviewRound: null,
    //   competencies: [
    //     {
    //       id: v4(),
    //       competency: null,
    //       count: null,
    //     },
    //   ],
    //   key: "1",
    // },
  ]);

  const getCompetencies = async (search = "") => {
    try {
      const result = await api.get(`/competencyNames?Search=${search}`, {
        tokenType: "user",
      });
      const { competencyNames } = result.data;
      let rows = [];
      for (let i = 0; i < competencyNames.length; i++) {
        rows.push({
          competencyNames: competencyNames[i].competencyNames,
          key: `${i + 1}`,
          _id: competencyNames[i]._id,
          sno: i + 1,
          status: competencyNames[i].status,
        });
      }
      setCompetencies(rows);
    } catch (err) {
      console.error(err);
    }
  };

  const getQuestions = async (search = "") => {
    try {
      const result = await api.get(`/competencyQuestionBank?Search=${search}`, {
        tokenType: "user",
      });
      const { competencyQuestionBank } = result.data;
      let rows = [];
      for (let i = 0; i < competencyQuestionBank.length; i++) {
        rows.push({
          question: competencyQuestionBank[i].question,
          key: `${i + 1}`,
          id: competencyQuestionBank[i]._id,
          _id: competencyQuestionBank[i]._id,
          competencyList: competencyQuestionBank[i].competencyList,
          sno: i + 1,
          status: competencyQuestionBank[i].status,
        });
      }
      setQuestions(rows);
      if (!search) {
        setQuestionsDataSource(rows);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getInterViewRounds = async () => {
    try {
      const result = await api.get(`/interviewNames`, { tokenType: "user" });
      const { interviewNames } = result.data;

      let rows = [];

      for (let i = 0; i < interviewNames.length; i++) {
        rows.push({
          interview_name: interviewNames[i].interviewNames,
          key: `${i + 1}`,
          id: interviewNames[i]._id,
          sno: i + 1,
          _id: interviewNames[i]._id,
          interviewNames: interviewNames[i].interviewNames,
          status: interviewNames[i].status,
        });
      }
      setInterviewRounds(rows);
      setInterviewsRound(rows);
    } catch (err) {
      console.error(err);
    }
  };

  // useEffect(() => {
  //   if (!departmentId) return;

  //   const init = async () => {
  //     try {
  //       setLoad(true);
  //       await getDesignations(departmentId);
  //     } catch (err) {
  //       console.error(err);
  //     } finally {
  //       setLoad(false);
  //     }
  //   };

  //   init();
  // }, [departmentId]);

  const getDepartments = async () => {
    try {
      const { data } = await api.get(`/trfdepartment`, {
        tokenType: "user",
      });

      const { trfDepartment } = data;
      setDepartments(trfDepartment.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  const getDesignations = async () => {
    try {
      const { data } = await api.get(`/designation`, {
        tokenType: "user",
      });

      const { designation } = data || {};
      setDesignations(designation?.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  const getDepartmentDesignationMapping = async () => {
    try {
      const { data } = await api.get(`/departmentBasedDesignation`, {
        tokenType: "user",
      });

      const { data: mapping } = data || {};
      setMapping(mapping?.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  const getCompetencyBasedQutionCount = async () => {
    try {
      setLoad(true);
      const result = await api.get(
        `/competencyQuestionBankSet/competencyQuestion/Count`,
        { tokenType: "user" },
      );
      setCompetencyQuestionCount(result.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      setLoad(true);
      await Promise.all([
        getCompetencies(),
        getQuestions(),
        getDepartments(),
        getDesignations(),
        getDepartmentDesignationMapping(),
        getInterViewRounds(),
        getCompetencyBasedQutionCount(),
      ]);
      setLoad(false);
    };
    init();
  }, []);

  const addCompetency = async (addAnother) => {
    try {
      setLoad(true);
      await api.post(
        `/competencyNames`,
        {
          competencyNames: competencyName,
          status: true,
        },
        { tokenType: "user" },
      );
      setCompetencyName("");
      if (!addAnother) setOpenCompetency(false);

      await getCompetencies();

      message.success("Competency added sucessfully.", 3);
    } catch (err) {
      console.error(err.response.data.error);
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  const editCompetency = async (_id) => {
    if (competencyName?.trim() === "") {
      return;
    }

    try {
      setLoad(true);
      await api.put(
        `/competencyNames/${_id}`,
        {
          competencyNames: competencyName,
          status: true,
        },
        { tokenType: "user" },
      );
      setCompetencyName("");
      setEditCompetencyName("");
      await getCompetencies();
      message.success("Competency Updated sucessfully.", 3);
    } catch (err) {
      console.error(err);
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  const deleteCompetency = async (_id) => {
    try {
      setLoad(true);
      await api.delete(`/competencyNames/${_id}`, { tokenType: "user" });
      await getCompetencies();
      setCompetencyId(null);
      message.success("Competency deleted sucessfully.", 3);
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.", 3);
    } finally {
      setLoad(false);
    }
  };

  const addQuestion = async (addAnother) => {
    try {
      setLoad(true);
      await api.post(
        `/competencyQuestionBankSet/SingleQuestion`,
        {
          // competencyNamesId: competencyId,
          competencyIdList: [competencyId],
          Question: question,
        },
        { tokenType: "user" },
      );
      setQuestion("");
      if (!addAnother) setOpenAddQuestion(false);
      await getQuestions();
      await getCompetencyBasedQutionCount();
      await getCompetencyBasedQuetions(competencyId);
      message.success("Question added successfully.", 3);
    } catch (err) {
      console.error(err);
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  const editQuestionHandler = async (_id) => {
    if (question?.trim() === "") {
      return;
    }
    try {
      setLoad(true);
      await api.put(
        `/competencyQuestionBank/${_id}`,
        {
          question: question,
          status: true,
        },
        { tokenType: "user" },
      );
      setQuestion("");
      setEditQuestion("");
      await getQuestions();

      if (competencyId) {
        await getCompetencyBasedQuetions(competencyId);
      }

      message.success("Question Updated sucessfully.", 3);
    } catch (err) {
      console.error(err);
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  const deleteQuestion = async (_id) => {
    try {
      setLoad(true);
      await api.delete(`/competencyQuestionBank/${_id}`, { tokenType: "user" });
      await getQuestions();
      await getCompetencyBasedQutionCount();
      message.success("Question deleted sucessfully.", 3);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  const deleteQuestionMaping = async (_id) => {
    try {
      setLoad(true);
      await api.delete(`/competencyQuestionBankSet/CompetencyQuestion/${_id}`, {
        tokenType: "user",
      });
      await getQuestions();
      if (competencyId) {
        await getCompetencyBasedQuetions(competencyId);
      }
      await getCompetencyBasedQutionCount();
      message.success("Question deleted sucessfully.", 3);
    } catch (err) {
      console.error(err);
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  const addInterViewRound = async (addAnother) => {
    try {
      setLoad(true);
      await api.post(
        `/interviewNames`,
        {
          interviewNames: interview,
          status: true,
        },
        { tokenType: "user" },
      );
      setInterview("");
      if (!addAnother) setOpenAddInterviewRounds(false);
      await getInterViewRounds();
      message.success("Interview added sucessfully.", 3);
    } catch (err) {
      console.error(err);
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  const editInterview = async (_id) => {
    if (interview?.trim() === "") {
      return;
    }
    try {
      setLoad(true);
      await api.put(
        `/interviewNames/${_id}`,
        {
          interviewNames: interview,
          status: true,
        },
        { tokenType: "user" },
      );
      setInterview("");
      setEditInterviewRound("");
      await getInterViewRounds();
      message.success("Interview Updated sucessfully.", 3);
    } catch (err) {
      console.error(err);
      message.error(err.response.data.error, 3);
    } finally {
      setLoad(false);
    }
  };

  const deleteInterview = async (_id) => {
    try {
      setLoad(true);
      await api.delete(`/interviewNames/${_id}`, { tokenType: "user" });
      await getInterViewRounds();
      message.success("Interview deleted sucessfully.", 3);
    } catch (err) {
      message.error(err.response.data.error, 3);
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  const RowContext = React.createContext({});

  const DragHandle = () => {
    const { setActivatorNodeRef, listeners } = useContext(RowContext);
    return (
      <Button
        type="text"
        size="small"
        icon={<MenuOutlined />}
        style={{
          cursor: "move",
        }}
        ref={setActivatorNodeRef}
        {...listeners}
      />
    );
  };

  const Row = (props) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
      setActivatorNodeRef,
    } = useSortable({
      id: props["data-row-key"],
    });
    const style = {
      ...props.style,
      transform: CSS.Translate.toString(transform),
      transition,
      ...(isDragging
        ? {
          position: "relative",
          zIndex: 99,
        }
        : {}),
    };

    const contextValue = useMemo(
      () => ({
        setActivatorNodeRef,
        listeners,
      }),
      [setActivatorNodeRef, listeners],
    );
    return (
      <RowContext.Provider value={contextValue}>
        <tr {...props} ref={setNodeRef} style={style} {...attributes} />
      </RowContext.Provider>
    );
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    }),
  );

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setTableData((prev) => {
        const activeIndex = prev.findIndex((i) => i.key === active.id);
        const overIndex = prev.findIndex((i) => i.key === over?.id);
        return arrayMove(prev, activeIndex, overIndex);
      });
      // if (selectedRow.length !== 0) {
      //   setTableData((prev) => {
      //     const activeIndex = prev.findIndex((i) => i.key === active.id);
      //     const overIndex = prev.findIndex((i) => i.key === over?.id);
      //     return arrayMove(prev, activeIndex, overIndex);
      //   });
      // }
    }
  };

  const changeHandler = (_id, type, value, record, recId = null) => {
    let arr = [...tableData];
    // let isDuplicate = false;
    arr.forEach((ele) => {
      if (ele.id === _id) {
        if (type === "interview") {
          // isDuplicate = tableData.some(
          //   (row) =>
          //     row.interviewRound === value &&
          //     row.competency === arr.find((ele) => ele.id === _id).competency
          // );
          // if (!isDuplicate) {
          //   ele.interviewRound = value;
          // } else {
          //   message.error(
          //     "This combination of Interview Round and Competency already exists!",
          //     2
          //   );
          //   return;
          // }
          ele.interviewRound = value;
        } else if (type === "competency") {
          const updateCompetencies = ele.competencies.map((comp) => {
            if (comp.id === recId) {
              return {
                ...comp,
                competency: value,
                count: null,
              };
            } else {
              return comp;
            }
          });

          ele.competencies = updateCompetencies;

          // isDuplicate = tableData.some(
          //   (row) =>
          //     row.interviewRound ===
          //       arr.find((ele) => ele.id === _id).interviewRound &&
          //     row.competency === value
          // );
          // if (!isDuplicate) {
          //   ele.competency = value;
          //   ele.count = null;
          // } else {
          //   message.error(
          //     "This combination of Interview Round and Competency already exists!",
          //     2
          //   );
          //   return;
          // }
        } else if (type === "count") {
          if (value <= 0) {
            return;
          }
          const val = competencyQuestionCount.find(
            (ele) =>
              ele.competencyNamesId ===
              record.competencies.find((_ele) => _ele.id === recId)?.competency,
          );
          if (val.count < value) {
            return;
          }
          const updateCompetencies = ele.competencies.map((comp) => {
            if (comp.id === recId) {
              return {
                ...comp,
                count: value,
              };
            } else {
              return comp;
            }
          });

          ele.competencies = updateCompetencies;
        }
      }
    });

    setTableData(arr);
  };

  const hasValidDepartments = (arr) => {
    return arr.every((item) => item.departmentId !== null) ? true : null;
  };

  const getDesignationBasedInterview = async (departmentId, designationId, type) => {
    if (type === "department") {
      const callApi = hasValidDepartments(
        designationBasedinterviewCompetencyQuestion,
      );
      if (
        callApi === null &&
        designationBasedinterviewCompetencyQuestion.length > 0
      ) {
        return;
      }
    }
    try {
      setLoad(true);
      const result = await api.get(
        `/competencyInterviewSetUp/designationId/${designationId}/departmentId/${departmentId}`,
        { tokenType: "user" },
      );

      const rows = result.data || [];
      setDesignationBasedinterviewCompetencyQuestion(rows);

      if (rows.length > 0) {
        rows.sort((a, b) => a.interviewNo - b.interviewNo);
        const arr = rows.map((ele, index) => {
          const hasCompetency = ele?.competencyintervieweetupsData.length === 0;
          return {
            id: ele?._id,
            interviewRound: ele?.interviewNamesId,
            key: `${index + 1}`,
            competencies: hasCompetency
              ? [
                {
                  id: v4(),
                  competency: null,
                  count: null,
                },
              ]
              : [
                ...ele?.competencyintervieweetupsData.map((_ele) => ({
                  competency: _ele?.competencyNamesId,
                  count: _ele?.maxQuestion,
                  id: _ele?._id,
                })),
              ],
          };
        });
        setTableData(arr);
      } else {
        setTableData([
          // {
          //   id: v4(),
          //   interviewRound: null,
          //   competencies: [
          //     {
          //       id: v4(),
          //       competency: null,
          //       count: null,
          //     },
          //   ],
          //   key: "1",
          // },
        ]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  const mapInterviewsWithCompetencyWithQuestion = async () => {
    let data = tableData.map((row, index) => ({
      interviewNamesId: row.interviewRound,
      interviewNo: index + 1,
      competencyList: [
        ...row.competencies
          .map((item) => {
            if (item.competency !== null && item.count !== null) {
              return {
                competencyNamesId: item.competency,
                maxQuestion: item.count,
              };
            }
          })
          .filter(Boolean),
      ],
    }));
    try {
      setLoad(true);
      await api.post(
        `/competencyInterviewSetUp/questionSetUp`,
        {
          designationId: designationId,
          departmentId: departmentId,
          interviewList: data,
        },
        { tokenType: "user" },
      );
      setDesignationId(null);
      setDepartmentId(null);
      setTableData([
        // {
        //   id: v4(),
        //   interviewRound: null,
        //   competencies: [
        //     {
        //       id: v4(),
        //       competency: null,
        //       count: null,
        //     },
        //   ],
        //   key: "1",
        // },
      ]);
      setDesignationBasedinterviewCompetencyQuestion([]);
      if (designationBasedinterviewCompetencyQuestion.length !== 0) {
        message.success(
          `Competency have been successfully updated with the Interviews.`,
          3,
        );
      } else {
        message.success(
          `Competency have been successfully linked to the Interviews.`,
          3,
        );
      }
    } catch (err) {
      console.error(err);
      message.error(err?.response?.data?.error || "Something went wrong. Try again.")
    } finally {
      setLoad(false);
    }
  };

  const deleteRecord = async (_id) => {
    setTableData([...tableData?.filter((ele) => ele.id !== _id)]);
  };

  const getCompetencyBasedQuetions = async (_id) => {
    try {
      setLoad(true);
      const result = await api.get(
        `/competencyQuestionBankSet/competencyId/${_id}?Search=${competencybasedQuestionSearch || ""
        }`,
        { tokenType: "user" },
      );
      const { competencyQuestionBank } = result.data;
      let rows = [];
      for (let i = 0; i < competencyQuestionBank.length; i++) {
        rows.push({
          question:
            competencyQuestionBank[i]?.competencyQuestionBankId?.question,
          _id: competencyQuestionBank[i]?.competencyQuestionBankId?._id,
          mappingId: competencyQuestionBank[i]?._id,
          status: true,
          competencyList: competencyQuestionBank[i]?.competencyList,
          sno: i + 1,
        });
      }
      setCompetencyWithQuetionBank(rows);
      if (competencyQuestionBank.length !== 0) {
        setSelectedQueRowKeys([
          ...competencyQuestionBank.map(
            (ele) =>
              questionsDataSource.find(
                (_ele) => ele.competencyQuestionBankId?._id === _ele.id,
              )?.key,
          ),
        ]);
        setSelectedQueRow([
          ...competencyQuestionBank.map((ele) =>
            questionsDataSource.find(
              (_ele) => ele.competencyQuestionBankId?._id === _ele.id,
            ),
          ),
        ]);
      } else {
        setSelectedQueRowKeys([]);
        setSelectedQueRow([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  const submitCompetencyBasedQuetions = async (
    queId = null,
    compId = null,
    e = null,
    mappingId = null,
  ) => {
    try {
      if (e.target.checked) {
        let data = [];
        let competencyNamesId = competencyId;
        if (queId && compId) {
          data.push({
            competencyQuestionBankId: queId,
            serialNo: null,
          });
          competencyNamesId = compId;
          try {
            setLoad(true);
            await api.post(
              `/competencyQuestionBankSet/questionBasedCompetencySetUp`,
              {
                competencyNamesId: competencyNamesId,
                questionBankList: data,
              },
              { tokenType: "user" },
            );
          } catch (err) {
            console.error(err);
          }
        } else {
          data = selectedQueRow.map((row, index) => ({
            competencyQuestionBankId: row.id,
            serialNo: null,
          }));
          try {
            setLoad(true);
            await api.post(
              `/competencyQuestionBankSet`,
              {
                competencyNamesId: competencyNamesId,
                questionBankList: data,
              },
              { tokenType: "user" },
            );
          } catch (err) {
            console.error(err);
          }
        }
        await getQuestions();
        if (competencyId) {
          await getCompetencyBasedQuetions(competencyId);
        }
        await getCompetencyBasedQutionCount();
        if (competencyWithQuetionBank.length !== 0) {
          message.success(
            `Questions have been successfully updated with the Competency.`,
            3,
          );
        } else {
          message.success(
            `Questions have been successfully linked to the Competency.`,
            3,
          );
        }
      } else {
        if (mappingId) deleteQuestionMaping(mappingId);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };
  // const disableInterviewSetupSubmit = () => {
  //   const isDisabled = tableData.every((row) => {
  //     return Object.values(row).every((value) => {
  //       if (
  //         typeof value === "object" &&
  //         value !== null &&
  //         !Array.isArray(value)
  //       ) {
  //         return Object.values(value).every(
  //           (nestedValue) => nestedValue !== null && nestedValue !== ""
  //         );
  //       } else if (Array.isArray(value)) {
  //         return value.every((item) => {
  //           if (typeof item === "object" && item !== null) {
  //             return Object.values(item).every(
  //               (nestedValue) => nestedValue !== null && nestedValue !== ""
  //             );
  //           } else {
  //             return item !== null && item !== "";
  //           }
  //         });
  //       } else {
  //         return value !== null && value !== "";
  //       }
  //     });
  //   });

  //   return !isDisabled;
  // };

  const disableInterviewSetupSubmit = () => {
    if (tableData?.length === 0) return true;

    for (const item of tableData) {
      if (!item.interviewRound) {
        return true;
      }
      if (item.competencies && Array.isArray(item.competencies)) {
        for (const competencyObj of item.competencies) {
          if (
            competencyObj.competency !== null &&
            competencyObj.count === null
          ) {
            return true;
          }
        }
      } else {
        return true;
      }
    }
    return false;
  };

  const reseTStates = (activeKey) => {
    if (activeKey === "1") {
      setCompetencyId(null);
    }
    if (activeKey === "2") {
      setDesignationId(null);
      setSelectedRowKeys([]);
      setSelectedRow([]);
      setTableData([
        // {
        //   id: v4(),
        //   interviewRound: null,
        //   competencies: [
        //     {
        //       id: v4(),
        //       competency: null,
        //       count: null,
        //     },
        //   ],
        //   key: "1",
        // },
      ]);
    }
  };

  // useEffect(() => {
  //   let timeOut = null;
  //   if (competencySearch !== null) {
  //     timeOut = setTimeout(async () => {
  //       getCompetencies(competencySearch);
  //     }, 500);
  //   }
  //   return () => {
  //     if (timeOut) {
  //       clearTimeout(timeOut);
  //     }
  //   };
  // }, [competencySearch]);

  // useEffect(() => {
  //   let timeOut = null;
  //   if (questionSearch !== null || competencybasedQuestionSearch !== null) {
  //     timeOut = setTimeout(async () => {
  //       if (competencyId) {
  //         getCompetencyBasedQuetions(competencyId);
  //       } else {
  //         getQuestions(questionSearch);
  //       }
  //     }, 500);
  //   } c
  //   return () => {
  //     if (timeOut) {
  //       clearTimeout(timeOut);
  //     }
  //   };
  // }, [questionSearch, competencybasedQuestionSearch]);

  const getCompetenciesName = (_id) => {
    const name = competencies.find((ele) => ele._id === _id)?.competencyNames;
    return name;
  };

  const competencyHadAtleastOneQuestion = competencies.filter((item) =>
    competencyQuestionCount.some(
      (arr1Item) => arr1Item.competencyNamesId === item._id,
    ),
  );

  const onAddCompetency = (_id) => {
    const arr = tableData.map((record) => {
      if (record.id === _id) {
        const updateCompetencies = [
          ...record.competencies,
          {
            id: v4(),
            competency: null,
            count: null,
          },
        ];
        return {
          ...record,
          competencies: updateCompetencies,
        };
      } else {
        return record;
      }
    });

    setTableData(arr);
  };

  const onRemoveCompetency = (_id, recid) => {
    const arr = tableData.map((record) => {
      if (record.id === _id) {
        const updateCompetencies = record.competencies.filter(
          (ele) => ele.id !== recid,
        );
        return {
          ...record,
          competencies: updateCompetencies,
        };
      } else {
        return record;
      }
    });

    setTableData(arr);
  };

  const filteredCompetencies = useMemo(() => {
    if (!competencySearch) return competencies;
    return competencies.filter((item) =>
      item.competencyNames
        ?.toLowerCase()
        .includes(competencySearch?.toLowerCase()),
    );
  }, [competencies, competencySearch]);

  const filteredQuestions = useMemo(() => {
    if (!questionSearch) return questions;
    return questions.filter((item) =>
      item.question?.toLowerCase().includes(questionSearch?.toLowerCase()),
    );
  }, [questions, questionSearch]);

  const filteredCompetencyBasedQuestions = useMemo(() => {
    if (!competencybasedQuestionSearch) return competencyWithQuetionBank;
    return competencyWithQuetionBank.filter((item) =>
      item.question
        ?.toLowerCase()
        .includes(competencybasedQuestionSearch?.toLowerCase()),
    );
  }, [competencyWithQuetionBank, competencybasedQuestionSearch]);

  const deleteInterviewSetup = async () => {
    try {
      await api.put(
        `/competencyInterviewSetUp/designationId/${designationId}/departmentId/${departmentId}`,
        {},
        { tokenType: "user" },
      );
      setDesignationId(null);
      setDepartmentId(null);
      setTableData([
        // {
        //   id: v4(),
        //   interviewRound: null,
        //   competencies: [
        //     {
        //       id: v4(),
        //       competency: null,
        //       count: null,
        //     },
        //   ],
        //   key: "1",
        // },
      ]);
      setDesignationBasedinterviewCompetencyQuestion([]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoad(false);
    }
  };

  const filteredDesignations = useMemo(() => {
    if (!departmentId) return designations;

    return designations.filter((d) =>
      mapping.some(
        (m) =>
          m.departmentId?._id === departmentId &&
          m.designationId?._id === d._id,
      ),
    );
  }, [designations, departmentId]);

  const filteredDepartments = useMemo(() => {
    if (!designationId) return departments;

    return departments.filter((dept) =>
      mapping.some(
        (m) =>
          m.designationId?._id === designationId &&
          m.departmentId?._id === dept._id,
      ),
    );
  }, [designationId, departments]);

  return (
    <Dashboard title="Documents">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}

      <div className="d-flex justify-content-between align-items-center py-1 mb-3">
        <h4 className="fw-normal">Configurations</h4>
      </div>

      <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
        <Tabs
          className="w-100 custom-tabs"
          defaultActiveKey="1"
          onChange={(activeKey) => {
            reseTStates(activeKey);
          }}
          tabBarStyle={{
            color: "black",
            borderBottom: "2px solid grey",
            width: "100%",
          }}
        >
          <TabPane className="w-100" tab="Master Setup" key="1">
            <Card
              title="Interview Round"
              extra={
                canCreateInterviewRound && (
                  <Button
                    className="text-white"
                    type="link"
                    onClick={() => setOpenAddInterviewRounds(true)}
                  >
                    [ + Add ]
                  </Button>
                )
              }
            >
              <List
                dataSource={interviewRounds}
                pagination={{
                  position: "bottom",
                  total: interviewRounds.length,
                  showSizeChanger: false,
                  pageSize: 5,
                }}
                renderItem={(item) =>
                  item.status && (
                    <List.Item
                      actions={[
                        editInterviewRound === item._id ? (
                          <div className="d-flex gap-1">
                            <CheckOutlined
                              onClick={() => {
                                editInterview(item?._id);
                              }}
                              style={{ fontSize: "15px", color: "green" }}
                            />
                            <CloseOutlined
                              onClick={() => {
                                setEditInterviewRound("");
                              }}
                              style={{ fontSize: "15px", color: "black" }}
                            />
                          </div>
                        ) : (
                          <div className="d-flex gap-1">
                            {canEditInterviewRound && (
                              <EditOutlined
                                onClick={() => {
                                  setEditInterviewRound(item?._id);
                                  setInterview(item?.interviewNames);
                                }}
                                style={{ fontSize: "15px", color: "black" }}
                              />
                            )}
                            {canDeleteInterviewRound && (
                              <CloseOutlined
                                onClick={async () => {
                                  const flag = await swal({
                                    title: "Warning",
                                    icon: "warning",
                                    content: {
                                      element: "div",
                                      attributes: {
                                        innerHTML: `<p style="text-align:center">This Interview is associated with one or more roles. Are you sure you want to proceed with deleting the Interview?</p>`,
                                      },
                                    },
                                    buttons: {
                                      cancel: true,
                                      confirm: true,
                                    },
                                  });

                                  if (flag) {
                                    deleteInterview(item?._id);
                                  }
                                }}
                                style={{ fontSize: "15px", color: "black" }}
                              />
                            )}
                          </div>
                        ),
                      ]}
                    >
                      {editInterviewRound === item?._id ? (
                        <>
                          <div style={{ width: "85%" }}>
                            <Input
                              type="text"
                              style={{ width: "100%" }}
                              value={interview}
                              onChange={(e) => setInterview(e.target.value)}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          {item?.sno}. {item?.interviewNames}
                        </>
                      )}
                    </List.Item>
                  )
                }
              />
            </Card>

            <div className="row mt-5 ">
              <div className="col-4">
                <Card
                  title="Competencies"
                  extra={
                    canCreateCompetencies && (
                      <Button
                        className="text-white"
                        type="link"
                        onClick={() => {
                          setOpenCompetency(true);
                          setCompetencyName("");
                          setEditCompetencyName("");
                        }}
                      >
                        [ + Add ]
                      </Button>
                    )
                  }
                >
                  <Input.Search
                    value={competencySearch}
                    placeholder="Search"
                    onChange={(e) => {
                      setCompetencySearch(e.target.value);
                    }}
                    style={{ marginBottom: 16 }}
                  />
                  <List
                    dataSource={filteredCompetencies}
                    pagination={{
                      position: "bottom",
                      total: filteredCompetencies.length,
                      showSizeChanger: false,
                      pageSize: 5,
                    }}
                    renderItem={(item) => {
                      const questionCount =
                        competencyQuestionCount?.find(
                          (ele) => ele.competencyNamesId === item?._id,
                        )?.count || 0;
                      if (item.status) {
                        return (
                          <List.Item
                            className={`${competencyId === item?._id ? "active" : ""
                              } ${questionCount === 0 ? "text-danger" : "text-black"
                              }`}
                            actions={[
                              editCompetencyName === item._id ? (
                                <div className="d-flex gap-1">
                                  <CheckOutlined
                                    onClick={() => {
                                      editCompetency(item?._id);
                                    }}
                                    style={{ fontSize: "15px", color: "green" }}
                                  />
                                  <CloseOutlined
                                    onClick={() => {
                                      setEditCompetencyName("");
                                    }}
                                    style={{ fontSize: "15px", color: "black" }}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex gap-1">
                                  {canEditCompetencies && (
                                    <EditOutlined
                                      onClick={() => {
                                        setEditCompetencyName(item?._id);
                                        setCompetencyName(item?.competencyNames);
                                      }}
                                      style={{ fontSize: "15px", color: "black" }}
                                    />
                                  )}
                                  {canDeleteCompetencies && (
                                    <CloseOutlined
                                      onClick={async () => {
                                        const flag = await swal({
                                          title: "Warning",
                                          icon: "warning",
                                          content: {
                                            element: "div",
                                            attributes: {
                                              innerHTML:
                                                questionCount === 0
                                                  ? `<p style="text-align:center">Are you sure you want to proceed with deleting the competency?</p>`
                                                  : `<p style="text-align:center">Please remove the question first, then delete this competency.</p>`,
                                            },
                                          },
                                          buttons: {
                                            cancel: true,
                                            confirm:
                                              questionCount === 0 ? true : false,
                                          },
                                        });

                                        if (flag) {
                                          deleteCompetency(item?._id);
                                        }
                                      }}
                                      style={{ fontSize: "15px", color: "black" }}
                                    />
                                  )}
                                </div>
                              ),
                            ]}
                          >
                            {editCompetencyName === item?._id ? (
                              <>
                                <div style={{ width: "85%" }}>
                                  <Input
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={competencyName}
                                    onChange={(e) =>
                                      setCompetencyName(e.target.value)
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              <div
                                onClick={(e) => {
                                  getCompetencyBasedQuetions(item?._id);
                                  setCompetencybasedQuestionSearch(null);
                                  setQuestionSearch(null);
                                  setCompetencyId(item?._id);
                                }}
                                className="w-100"
                              >
                                {item?.sno}. {item?.competencyNames} (
                                {questionCount})
                              </div>
                            )}
                          </List.Item>
                        );
                      }
                    }}
                  />
                </Card>
              </div>
              <div className="col-8">
                <Card
                  title="Question Bank"
                  extra={
                    canCreateQuestionBank && (
                      <Button
                        className="text-white"
                        type="link"
                        onClick={() => setOpenAddQuestion(true)}
                      >
                        [ + Add ]
                      </Button>
                    )
                  }
                >
                  <div className="row">
                    <div className="col-md-7">
                      <h6 className=" m-0 fw-bold">
                        {!competencyId ? (
                          "All"
                        ) : (
                          <div className="row align-items-center">
                            <div className="">
                              {getCompetenciesName(competencyId)}
                            </div>
                            <div className="">
                              <Button
                                className="text-dark"
                                type="link"
                                onClick={() => {
                                  setCompetencyId(null);
                                  setCompetencybasedQuestionSearch(null);
                                  setQuestionSearch(null);
                                  getQuestions();
                                  setSelectedQueRow([]);
                                  setSelectedQueRowKeys([]);
                                }}
                              >
                                [ View All Question ]
                              </Button>
                            </div>
                          </div>
                        )}
                      </h6>
                    </div>
                    <div className="col-md-5">
                      <Input.Search
                        value={questionSearch || competencybasedQuestionSearch}
                        placeholder="Search"
                        onChange={(e) => {
                          if (competencyId) {
                            setCompetencybasedQuestionSearch(e.target.value);
                          } else {
                            setQuestionSearch(e.target.value);
                          }
                        }}
                        style={{ marginBottom: 16 }}
                      />
                    </div>
                  </div>
                  <List
                    key={competencyId}
                    dataSource={
                      competencyId
                        ? filteredCompetencyBasedQuestions
                        : filteredQuestions
                    }
                    pagination={{
                      position: "bottom",
                      total: competencyId
                        ? filteredCompetencyBasedQuestions.length
                        : filteredQuestions.length,
                      showSizeChanger: false,
                      pageSize: 5,
                    }}
                    renderItem={(item, index) => {
                      if (item.status) {
                        return (
                          <List.Item
                            actions={[
                              editQuestion === item._id ? (
                                <div className="d-flex gap-1">
                                  <CheckOutlined
                                    onClick={() => {
                                      editQuestionHandler(item?._id);
                                    }}
                                    style={{ fontSize: "15px", color: "green" }}
                                  />
                                  <CloseOutlined
                                    onClick={() => {
                                      setEditQuestion("");
                                    }}
                                    style={{ fontSize: "15px", color: "black" }}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex gap-1">
                                  {
                                    canCreateQuestionBank && (
                                      <Dropdown
                                        menu={{
                                          items: competencies.map((comp) => {
                                            const questionCount =
                                              competencyQuestionCount?.find(
                                                (ele) =>
                                                  ele.competencyNamesId ===
                                                  comp?._id,
                                              )?.count || 0;
                                            const mappingId =
                                              item?.competencyList?.find(
                                                (ele) =>
                                                  ele.competencyNamesId ===
                                                  comp?._id,
                                              )?._id;
                                            const defaultChecked =
                                              item?.competencyList?.some(
                                                (ele) =>
                                                  ele.competencyNamesId ===
                                                  comp?._id,
                                              );
                                            return {
                                              label: (
                                                <div
                                                  className={`${questionCount === 0
                                                    ? "text-danger"
                                                    : "text-black"
                                                    } d-flex gap-1`}
                                                  onClick={handleMenuClick}
                                                >
                                                  <Checkbox
                                                    key={
                                                      competencyId || competencies
                                                    }
                                                    onChange={(e) => {
                                                      submitCompetencyBasedQuetions(
                                                        item._id,
                                                        comp._id,
                                                        e,
                                                        mappingId,
                                                      );
                                                    }}
                                                    checked={defaultChecked}
                                                    // disabled={defaultChecked}
                                                    defaultChecked={defaultChecked}
                                                  />
                                                  {comp?.competencyNames} (
                                                  {questionCount})
                                                </div>
                                              ),
                                            };
                                          }),
                                        }}
                                        trigger={["click"]}
                                      >
                                        <PlusSquareOutlined
                                          style={{
                                            fontSize: "15px",
                                            color: "black",
                                          }}
                                          onClick={handleMenuClick}
                                        />
                                      </Dropdown>
                                    )
                                  }



                                  {canEditQuestionBank && (
                                    <EditOutlined
                                      onClick={() => {
                                        setEditQuestion(item?._id);
                                        setQuestion(item?.question);
                                      }}
                                      style={{ fontSize: "15px", color: "black" }}
                                    />
                                  )}
                                  {canDeleteQuestionBank && (
                                    <>{competencyId ? (
                                      <CloseOutlined
                                        onClick={async () => {
                                          const flag = await swal({
                                            title: "Warning",
                                            icon: "warning",
                                            content: {
                                              element: "div",
                                              attributes: {
                                                innerHTML:
                                                  item?.competencyList.length ===
                                                    0
                                                    ? `<p style="text-align:center">Are you sure want to delete?</p>`
                                                    : `<p style="text-align:center">Please remove the competency first, then delete this question.</p>`,
                                              },
                                            },
                                            buttons: {
                                              cancel: true,
                                              confirm:
                                                item?.competencyList.length === 0
                                                  ? true
                                                  : false,
                                            },
                                          });
                                          if (flag) {
                                            deleteQuestionMaping(item?.mappingId);
                                          }
                                        }}
                                        style={{
                                          fontSize: "15px",
                                          color: "black",
                                        }}
                                      />
                                    ) : (
                                      <CloseOutlined
                                        onClick={async () => {
                                          const flag = await swal({
                                            title: "Warning",
                                            icon: "warning",
                                            content: {
                                              element: "div",
                                              attributes: {
                                                innerHTML:
                                                  item?.competencyList.length ===
                                                    0
                                                    ? `<p style="text-align:center">Are you sure want to delete?</p>`
                                                    : `<p style="text-align:center">Please remove the competency first, then delete this question.</p>`,
                                              },
                                            },
                                            buttons: {
                                              cancel: true,
                                              confirm:
                                                item?.competencyList.length === 0
                                                  ? true
                                                  : false,
                                            },
                                          });
                                          if (flag) {
                                            deleteQuestion(item?._id);
                                          }
                                        }}
                                        style={{
                                          fontSize: "15px",
                                          color: "black",
                                        }}
                                      />
                                    )}</>
                                  )}
                                </div>
                              ),
                            ]}
                          >
                            {editQuestion === item?._id ? (
                              <>
                                <div style={{ width: "85%" }}>
                                  <Input
                                    type="text"
                                    style={{ width: "100%" }}
                                    value={question}
                                    onChange={(e) =>
                                      setQuestion(e.target.value)
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                {item?.sno}. {item?.question}
                              </>
                            )}
                          </List.Item>
                        );
                      }
                    }}
                  />
                </Card>
              </div>
            </div>
            <Space direct style={{ width: "100%", marginTop: 16 }}></Space>
          </TabPane>
          <TabPane tab="Interview Setup" key="2">
            <Card
              title="Interview Setup"
              className="mb-3"
              headStyle={{ backgroundColor: "#003366", color: "white" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "center",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <h5 className=" m-0 pr-2 fw-bold">Department: </h5>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        String(option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase()) ||
                        String(option?.value ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      );
                    }}
                    defaultValue=""
                    placeholder="Select Department"
                    style={{ width: 300 }}
                    value={departmentId}
                    onChange={(value) => {
                      setDepartmentId(value);

                      getDesignationBasedInterview(value, designationId, "department");
                    }}
                  >
                    <Select.Option value={null}>All Departments</Select.Option>
                    {filteredDepartments?.map((department) => {
                      return (
                        <Select.Option value={department?._id}>
                          {department?.department || department?.departmentName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <h5 className=" m-0 pr-2 fw-bold">Designation: </h5>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        String(option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase()) ||
                        String(option?.value ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      );
                    }}
                    defaultValue=""
                    placeholder="Select Designation"
                    style={{ width: 300 }}
                    value={designationId}
                    onChange={(value) => {
                      setDesignationId(value);
                      getDesignationBasedInterview(departmentId, value, "designation");
                    }}
                  >
                    <Select.Option value={null}>All Designations</Select.Option>
                    {filteredDesignations?.map((designation) => {
                      return (
                        <Select.Option value={designation?._id}>
                          {designation?.designation}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </Card>
            <DndContext
              sensors={sensors}
              modifiers={[restrictToVerticalAxis]}
              onDragEnd={onDragEnd}
            >
              <SortableContext
                items={tableData.map((i) => i.key)}
                strategy={verticalListSortingStrategy}
              >
                <Table
                  dataSource={tableData}
                  bordered
                  columns={[
                    {
                      title: "Interview Round",
                      dataIndex: "round",
                      key: "round",
                      width: 200,
                      render: (val, record) => (
                        <Select
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            return (
                              option?.children
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0 ||
                              option.value
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          placeholder="Select Interview"
                          onChange={(value) => {
                            changeHandler(
                              record.id,
                              "interview",
                              value,
                              record,
                            );
                          }}
                          value={record?.interviewRound}
                          style={{ width: "100%" }}
                        >
                          {interviewRounds?.map((ele) => {
                            const isInterviewSelected = tableData.some(
                              (_ele) => ele._id === _ele.interviewRound,
                            );
                            return (
                              <Select.Option
                                value={ele?._id}
                                disabled={isInterviewSelected}
                              >
                                {ele?.interviewNames}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      ),
                    },
                    {
                      title: () => (
                        <div
                          className="d-flex justify-content-between"
                          style={{ position: "relative" }}
                        >
                          <div style={{ width: "500px" }}>Competency</div>
                          <div
                            style={{
                              width: "200px",
                              position: "absolute",
                              left: "68.5%",
                            }}
                          >
                            Question Count
                          </div>
                        </div>
                      ),
                      dataIndex: "competency",
                      key: "competency",
                      width: 600,
                      render: (val, record) => {
                        return (
                          <div className="row">
                            {record.competencies.map((rec, index) => {
                              return (
                                <>
                                  <div className="col-md-6 mb-2">
                                    <Select
                                      showSearch
                                      optionFilterProp="children"
                                      filterOption={(input, option) => {
                                        const children = String(
                                          option?.children || "",
                                        );
                                        const value = String(
                                          option?.value || "",
                                        );
                                        const inputStr = String(
                                          input || "",
                                        ).toLowerCase();
                                        return (
                                          children
                                            .toLowerCase()
                                            .indexOf(inputStr) >= 0 ||
                                          value
                                            .toLowerCase()
                                            .indexOf(inputStr) >= 0
                                        );
                                      }}
                                      placeholder="Select Competency"
                                      onChange={(value) => {
                                        changeHandler(
                                          record.id,
                                          "competency",
                                          value,
                                          record,
                                          rec.id,
                                        );
                                      }}
                                      value={rec?.competency}
                                      style={{ width: "100%" }}
                                    >
                                      {competencyHadAtleastOneQuestion?.map(
                                        (ele) => {
                                          const questionCount =
                                            competencyQuestionCount?.find(
                                              (_ele) =>
                                                _ele.competencyNamesId ===
                                                ele?._id,
                                            )?.count || 0;
                                          const isCompSelected =
                                            record.competencies.some(
                                              (_ele) =>
                                                ele._id === _ele.competency,
                                            );
                                          // if(!isCompSelected){
                                          return (
                                            <Select.Option
                                              value={ele._id}
                                              disabled={isCompSelected}
                                            >
                                              {ele?.competencyNames} (
                                              {questionCount})
                                            </Select.Option>
                                          );
                                          // }
                                        },
                                      )}
                                    </Select>
                                  </div>
                                  <div className="col-md-2 mb-2">
                                    {index ===
                                      record.competencies.length - 1 ? (
                                      <>
                                        {record.competencies.length <
                                          competencyHadAtleastOneQuestion.length ? (
                                          <Button
                                            className="text-dark px-0"
                                            type="link"
                                            onClick={() =>
                                              onAddCompetency(record.id)
                                            }
                                          >
                                            [ + Add ]
                                          </Button>
                                        ) : (
                                          <>
                                            {record.competencies.length !==
                                              1 && (
                                                <Button
                                                  onClick={() =>
                                                    onRemoveCompetency(
                                                      record.id,
                                                      rec.id,
                                                    )
                                                  }
                                                  type="text"
                                                  icon={
                                                    <CloseOutlined
                                                      style={{
                                                        fontSize: "15px",
                                                        color: "black",
                                                      }}
                                                    />
                                                  }
                                                />
                                              )}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <Button
                                          onClick={() =>
                                            onRemoveCompetency(
                                              record.id,
                                              rec.id,
                                            )
                                          }
                                          type="text"
                                          icon={
                                            <CloseOutlined
                                              style={{
                                                fontSize: "15px",
                                                color: "black",
                                              }}
                                            />
                                          }
                                        />
                                      </>
                                    )}
                                  </div>
                                  <div className="col-md-4 d-flex align-items-center mb-2">
                                    <Button
                                      disabled={!rec?.competency}
                                      onClick={() => {
                                        changeHandler(
                                          record.id,
                                          "count",
                                          rec.count - 1,
                                          record,
                                          rec.id,
                                        );
                                      }}
                                    >
                                      -
                                    </Button>
                                    <InputNumber
                                      value={rec?.count}
                                      disabled={!rec?.competency}
                                      min={0}
                                      onChange={(value) => {
                                        changeHandler(
                                          record.id,
                                          "count",
                                          value,
                                          record,
                                          rec.id,
                                        );
                                      }}
                                      style={{ width: 60, margin: "0 8px" }}
                                    />
                                    <Button
                                      disabled={!rec?.competency}
                                      onClick={() => {
                                        changeHandler(
                                          record.id,
                                          "count",
                                          rec.count + 1,
                                          record,
                                          rec.id,
                                        );
                                      }}
                                    >
                                      +
                                    </Button>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        );
                      },
                    },
                    {
                      title: "Action",
                      key: "action",
                      fixed: "right",
                      width: 100,
                      render: (val, record) => (
                        <div className="d-flex gap-1 align-items-center">
                          {/* {tableData?.length !== 1 && ( */}
                          {canDeleteInterviewSetup && (
                            <Button
                              onClick={async () => {
                                if (
                                  tableData?.length === 1 &&
                                  designationBasedinterviewCompetencyQuestion.length !==
                                  0
                                ) {
                                  const flag = await swal({
                                    title: "Warning",
                                    icon: "warning",
                                    content: {
                                      element: "div",
                                      attributes: {
                                        innerHTML: `<p style="text-align:center">Do you want to remove the interview setup?</p>`,
                                      },
                                    },
                                    buttons: {
                                      cancel: true,
                                      confirm: true,
                                    },
                                  });

                                  if (flag) {
                                    deleteInterviewSetup();
                                  }
                                  return;
                                }
                                deleteRecord(record.id);
                              }}
                              type="text"
                              icon={
                                <CloseOutlined
                                  style={{ fontSize: "15px", color: "black" }}
                                />
                              }
                            />
                          )}
                          {/* )} */}
                          <DragHandle />
                        </div>
                      ),
                    },
                  ]}
                  pagination={false}
                  footer={() => (
                    <>
                      {canAddInterviewSetup && tableData.length <= interviewRounds.length && (
                        <Button
                          className="text-dark"
                          type="link"
                          disabled={!departmentId || !designationId}
                          onClick={() => {
                            setTableData([
                              ...tableData,
                              {
                                id: v4(),
                                interviewRound: null,
                                competencies: [
                                  {
                                    id: v4(),
                                    competency: null,
                                    count: null,
                                  },
                                ],
                                key: `${tableData.length + 1}`,
                              },
                            ]);
                          }}
                        >
                          [ + Add Interview Round ]
                        </Button>
                      )}
                    </>
                  )}
                  components={{
                    body: {
                      row: Row,
                    },
                  }}
                  rowKey="key"
                  className="interview-setup-table"
                />
              </SortableContext>
            </DndContext>
            {canSubmitInterviewSetup && (
              <div className="w-100 d-flex justify-content-center mt-4">
                <button
                  className={`btn ${!disableInterviewSetupSubmit() &&
                    designationId !== null &&
                    departmentId !== null
                    ? "btn-primary"
                    : "btn-secondary"
                    }`}
                  disabled={
                    disableInterviewSetupSubmit() ||
                    designationId === null ||
                    departmentId === null
                  }
                  onClick={() => mapInterviewsWithCompetencyWithQuestion()}
                >
                  {designationBasedinterviewCompetencyQuestion.length !== 0
                    ? "Update"
                    : "Submit"}
                </button>
              </div>
            )}
          </TabPane>
        </Tabs>
      </div>
      <Modal
        open={openAddInterviewRounds}
        onCancel={() => setOpenAddInterviewRounds(!openAddInterviewRounds)}
        footer={
          <div className="row">
            <div className="col-md-12 d-flex gap-1 justify-content-center">
              <button
                className={`btn ${interview.trim() !== "" ? "btn-primary" : "btn-secondary"
                  }`}
                disabled={interview.trim() !== "" ? false : true}
                onClick={() => addInterViewRound(false)}
              >
                Submit
              </button>
              <button
                className={`btn ${interview.trim() !== "" ? "btn-primary" : "btn-secondary"
                  }`}
                disabled={interview.trim() !== "" ? false : true}
                onClick={() => addInterViewRound(true)}
              >
                Submit & Add Another
              </button>
            </div>
          </div>
        }
        title={null}
        width={650}
        closable={true}
        className="p-0 custom_modal__"
      >
        <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white">
          <h5 className="modal-title text-white">Add a Interview Round</h5>
        </div>
        <div className="modal-body">
          <div className="form-group col-md-12 form-builder-element">
            <label htmlFor="">Interview Round Name</label>
            <textarea
              placeholder="Type here..."
              className="border form-control"
              onChange={(e) => setInterview(e.target.value)}
              value={interview}
            ></textarea>
          </div>
        </div>
      </Modal>
      <Modal
        open={openCompetency}
        onCancel={() => setOpenCompetency(!openCompetency)}
        footer={
          <div className="row">
            <div className="col-md-12 d-flex gap-1 justify-content-center">
              <button
                className={`btn ${competencyName.trim() !== "" ? "btn-primary" : "btn-secondary"
                  }`}
                disabled={competencyName.trim() !== "" ? false : true}
                onClick={() => addCompetency(false)}
              >
                Submit
              </button>
              <button
                className={`btn ${competencyName.trim() !== "" ? "btn-primary" : "btn-secondary"
                  }`}
                disabled={competencyName.trim() !== "" ? false : true}
                onClick={() => addCompetency(true)}
              >
                Submit & Add Another
              </button>
            </div>
          </div>
        }
        title={null}
        width={650}
        closable={true}
        className="p-0 custom_modal__"
      >
        <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white">
          <h5 className="modal-title text-white">Add a Competency</h5>
        </div>
        <div className="modal-body">
          <div className="form-group col-md-12 form-builder-element">
            <label htmlFor="">Competency Name</label>
            <textarea
              placeholder="Type here..."
              className="border form-control"
              onChange={(e) => setCompetencyName(e.target.value)}
              value={competencyName}
            ></textarea>
          </div>
        </div>
      </Modal>
      <Modal
        open={openAddQuestion}
        onCancel={() => setOpenAddQuestion(!openAddQuestion)}
        footer={null}
        title={null}
        width={650}
        closable={true}
        className="p-0 custom_modal__"
      >
        <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white">
          <h5 className="modal-title text-white">Add a Question</h5>
        </div>
        <div className="modal-body">
          <Tabs
            className="w-100 custom-tabs"
            defaultActiveKey="1"
            onChange={(activeKey) => { }}
            tabBarStyle={{
              color: "black",
              borderBottom: "2px solid grey",
              width: "100%",
            }}
          >
            <TabPane tab="Add a Question" key="1">
              <div className="form-group col-md-12 form-builder-element">
                <label htmlFor="">Competencies</label>
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    return (
                      option?.children
                        ?.toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0 ||
                      option.value.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    );
                  }}
                  className="w-100"
                  defaultValue=""
                  // mode="multiple"
                  placeholder="Select Competency"
                  style={{ width: 250 }}
                  value={competencyId}
                  onChange={(value) => {
                    console.log(value, "Poddar");
                    setCompetencyId(value);
                    getCompetencyBasedQuetions(value);
                  }}
                >
                  {competencies?.map((comp) => {
                    return (
                      <Select.Option value={comp?._id}>
                        {comp?.competencyNames}
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
              <div className="form-group col-md-12 form-builder-element">
                <label htmlFor="">Question</label>
                <textarea
                  placeholder="Type question here..."
                  className="border form-control"
                  onChange={(e) => setQuestion(e.target.value)}
                  value={question}
                ></textarea>
              </div>
              <div className="row">
                <div className="col-md-12 d-flex gap-1 justify-content-center">
                  <button
                    className={`btn ${question.trim() !== "" && competencyId
                      ? "btn-primary"
                      : "btn-secondary"
                      }`}
                    disabled={
                      question.trim() !== "" && competencyId ? false : true
                    }
                    onClick={() => addQuestion(false)}
                  >
                    Submit
                  </button>
                  <button
                    className={`btn ${question.trim() !== "" && competencyId
                      ? "btn-primary"
                      : "btn-secondary"
                      }`}
                    disabled={
                      question.trim() !== "" && competencyId ? false : true
                    }
                    onClick={() => addQuestion(true)}
                  >
                    Submit & Add Another
                  </button>
                </div>
              </div>
            </TabPane>
            <TabPane tab="Insert from Library" key="2">
              <Table
                dataSource={questionsDataSource}
                scroll={{
                  y: 400,
                }}
                columns={[
                  {
                    title: "Questions",
                    dataIndex: "question",
                    key: "question",
                    filterDropdown: ({
                      setSelectedKeys,
                      selectedKeys,
                      confirm,
                    }) => {
                      return (
                        <>
                          <Input
                            autoFocus
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                              setSelectedKeys(
                                e.target.value ? [e.target.value] : [],
                              );
                              confirm({ closeDropdown: false });
                            }}
                            onBlur={() => {
                              confirm();
                            }}
                          ></Input>
                        </>
                      );
                    },
                    filterIcon: () => {
                      return <SearchOutlined />;
                    },
                    onFilter: (value, record) => {
                      return record.question
                        .toLowerCase()
                        .includes(value.toLowerCase());
                    },
                  },
                ]}
                pagination={false}
                rowSelection={{
                  type: "checkbox",
                  selectedRowKeys: selectedQueRowKeys,
                  onChange: (selectedRowKeys, selectedRows) => {
                    setSelectedQueRow(selectedRows);
                    setSelectedQueRowKeys(selectedRowKeys);
                  },
                  getCheckboxProps: (record) => {
                    return {
                      disabled: competencyId ? false : true,
                    };
                  },
                }}
                rowKey="key"
                className="interview-setup-table"
              />
              <div className="row mt-4">
                <div className="col-md-12 d-flex gap-1 justify-content-center">
                  <button
                    disabled={!competencyId || selectedQueRowKeys.length === 0}
                    className={`btn ${competencyId && selectedQueRowKeys.length !== 0
                      ? "btn-primary"
                      : "btn-secondary"
                      }`}
                    onClick={(e) => {
                      e.target.checked = true;
                      submitCompetencyBasedQuetions(null, null, e);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Modal>
    </Dashboard>
  );
};

export default CompetencyConf;
